






















































import { mapActions, mapGetters } from 'vuex'
import mixins from 'vue-typed-mixins'
import DraftElement from '@/calendesk/sections/section/mixins/DraftElement'
import UserSubscription from '@/calendesk/models/DTO/Response/UserSubscription'
import { DateTimeFormats } from '@/calendesk/models/DateTimeFormats'
import PayForBookingsWithUserSubscriptionRequestData
  from '@/calendesk/models/DTO/Request/PayForBookingsWithUserSubscriptionRequestData'
import { errorNotification } from '@/calendesk/prototypes/notifications'
import BasicUserSubscription from '@/calendesk/models/DTO/Response/BasicUserSubscription'
import Booking from '@/calendesk/models/DTO/Response/Booking'

export default mixins(DraftElement).extend({
  name: 'PayWithSubscriptionDialog',
  data () {
    return {
      selectedSubscriptionId: null as number | null
    }
  },
  computed: {
    ...mapGetters({
      confirmDialog: 'dialog/getConfirmDialog',
      confirmDialogLoader: 'dialog/getConfirmDialogLoader'
    }),
    acceptedSubscriptions (): UserSubscription[] {
      if (this.hasUserSubscriptions) {
        return this.user.subscriptions
          .filter((userSubscription: BasicUserSubscription) => userSubscription.isActive())
          .sort((a: BasicUserSubscription, b: BasicUserSubscription) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
      }

      return []
    },
    selectedSubscription (): UserSubscription | null {
      if (this.selectedSubscriptionId) {
        return this.acceptedSubscriptions.find(
          (sub: UserSubscription) => sub.id === this.selectedSubscriptionId
        ) || null
      }
      return null
    },
    bookings (): Booking[] {
      return this.confirmDialog.data?.bookings || []
    },
    bookingsOutsidePeriodCount (): number {
      if (!this.selectedSubscription || !this.selectedSubscription.currentPeriodEndsAt) {
        return 0
      }

      const periodEnd = this.$moment(this.selectedSubscription.currentPeriodEndsAt)

      return this.bookings.filter((booking: Booking) => {
        const bookingStart = this.$moment(booking.startsAt)
        return bookingStart.isAfter(periodEnd)
      }).length
    },
    showBillingPeriodWarning (): boolean {
      return this.bookingsOutsidePeriodCount > 0
    },
    formattedPeriodEndDate (): string {
      if (this.selectedSubscription?.currentPeriodEndsAt) {
        return this.$moment(this.selectedSubscription.currentPeriodEndsAt).format(DateTimeFormats.FULL)
      }
      return ''
    },
    billingPeriodWarningMessage (): string {
      const totalBookings = this.bookings.length
      const outsideCount = this.bookingsOutsidePeriodCount

      if (totalBookings === 1 || outsideCount === totalBookings) {
        // All bookings are outside the period (or just one booking)
        return this.$trans('subscription_billing_period_warning', { date: this.formattedPeriodEndDate })
      } else {
        // Some bookings are inside, some outside
        return this.$trans('subscription_billing_period_warning_partial', {
          outside: outsideCount,
          total: totalBookings,
          date: this.formattedPeriodEndDate
        })
      }
    }
  },
  methods: {
    ...mapActions({
      closeConfirmDialog: 'dialog/closeConfirmDialog',
      payForBookingsWithUserSubscription: 'subscription/payForBookingsWithUserSubscription'
    }),
    async confirmAction () {
      if (this.selectedSubscriptionId) {
        try {
          this.setConfirmDialogLoader(true)

          const paidIds = await this.payForBookingsWithUserSubscription(new PayForBookingsWithUserSubscriptionRequestData(this.confirmDialog.data.bookingIds, this.selectedSubscriptionId))
          this.confirmDialog.confirmHandler(paidIds)
        } catch (error) {
          errorNotification(null, error)
        }

        this.closeConfirmDialog()
        this.setConfirmDialogLoader(false)
      }
    },
    getSubscriptionText (userSubscription: UserSubscription) {
      return userSubscription.subscription.name + ` (${this.$moment(userSubscription.createdAt).format(DateTimeFormats.FULL_WITH_MONTH_TEXT_AND_TIME)} [${userSubscription.id}])`
    }
  }
})
